import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import NavigatingImpactDetails from "./component/NavigatingImpactDetails";

export default function NavigatingImpact() {
  return (
    <Layout>
      <NewsHeader>Navigating Impact Investment In Bangladesh</NewsHeader>
      <NavigatingImpactDetails />
    </Layout>
  );
}
